import Card from 'components/Card';
import React, { type PropsWithChildren } from 'react';

import s from './NothingToDisplay.module.scss';

type Props = {
  text?: string;
  isBordered?: boolean;
};

const displayAsText = ({ text, children }: Parameters<React.FC<PropsWithChildren<Props>>>[0]): boolean =>
  Boolean(text || !children || typeof children === 'string');

const NothingToDisplay: React.FC<PropsWithChildren<Props>> = ({ text, children, isBordered = true }) => (
  <Card isBordered={isBordered} className={s.card} style={{ borderStyle: (isBordered && 'dashed') || undefined }}>
    {displayAsText({ children, text }) ? (
      <p className='caption'>{text || children || 'Nothing to display'}</p>
    ) : (
      <div className={s.element_wrapper}>{children}</div>
    )}
  </Card>
);

export default NothingToDisplay;
